import { FaBed } from "react-icons/fa";
import { TbMassage } from "react-icons/tb";
import { RiHotelFill } from "react-icons/ri";
import { MdOutlinePageview } from "react-icons/md";
import { FaWifi } from "react-icons/fa";
import { RiVipCrown2Fill } from "react-icons/ri";



export const features = [
    {
      title: "Super Comfy Rooms",
      description: "Stay in cozy and fancy rooms with awesome furniture, soft beds, and cool gadgets.",
      icon: FaBed
    },
    {
      title: "Relaxing Spa",
      description: "Feel super relaxed with massages and treatments in our spa. We have cool things like steam rooms and saunas.",
      icon: TbMassage
    },
    {
      title: "Fancy Lounge Access",
      description: "Get special access to a private lounge with free snacks, business help, and a quiet place to relax.",
      icon: RiHotelFill
    },
    {
      title: "Amazing Views",
      description: "See really pretty sights from our hotel, like the city, nature, or the ocean.",
      icon: MdOutlinePageview
    },
    {
      title: "Cool Tech Stuff",
      description: "Stay connected with fast Wi-Fi and use smart controls in your room. We've got all the gadgets you need!",
      icon: FaWifi
    },
    {
      title: "Special Treats",
      description: "You get extra special things like faster check-in, more time in your room, and discounts on cool stuff. We want your stay to be super awesome!",
      icon: RiVipCrown2Fill
    }
]
  
